module.exports = __webpack_public_path__ + "static/media/nexus_mutants.53152f4c.svg";